import Service from "@ember/service";
import { ajax } from "discourse/lib/ajax";

export default class ProviderAdminService extends Service {
  async loadProviders(params = {}) {
    return await ajax("/admin/plugins/proxyviews-directory/networks", { data: params });
  }

  async loadProvider(id) {
    return await ajax(`/admin/plugins/proxyviews-directory/content/${id}`);
  }

  async saveProvider(id, data) {
    return await ajax(`/admin/plugins/proxyviews-directory/networks/${id}`, {
      type: "PUT",
      data: { provider: data },
    });
  }

  async saveProviderContent(id, data) {
    return await ajax(`/admin/plugins/proxyviews-directory/content/${id}`, {
      type: "PUT",
      data: data,
    });
  }

  async createProvider(data) {
    return await ajax("/admin/plugins/proxyviews-directory/networks", {
      type: "POST",
      data: { provider: data },
    });
  }

  async deleteProvider(id) {
    return await ajax(`/admin/plugins/proxyviews-directory/networks/${id}`, {
      type: "DELETE",
    });
  }

  async loadSummary(id) {
    return await ajax(`/admin/plugins/proxyviews-directory/networks/${id}/summary`);
  }

  async bulkUpdate(providerIds, status, verified) {
    return await ajax("/admin/plugins/proxyviews-directory/networks/bulk-update", {
      type: "POST",
      data: { provider_ids: providerIds, status, verified },
    });
  }
}
